import { CountyInfo } from '@msdyn365-commerce/retail-proxy';
import { Modal, ModalBody } from '@msdyn365-commerce-modules/utilities';
import React from 'react';
import { YourLocation } from '../../../icons/your-location';
import DropdownWithSearch from '../../../components/dropdown-with-search';

interface IProps {
    isOpen: boolean;
    values: CountyInfo[];
    selectedValue?: CountyInfo;
    errorMessage?: string;
    onSelect: (value: CountyInfo) => Promise<void>;
    resources: IResources;
}

interface IResources {
    headerLabel: string; // Please enter your location
    subheaderLabel: string; // To browse the best offers based on your area
    dropdownLabel: string; // For all regions of the kingdom, click here
    saveLabel: string; // Save
    savingLabel: string; // Saving..
}

export const ZoneSelectorModal = ({ values, selectedValue, isOpen, errorMessage, onSelect, resources }: IProps) => {
    const { headerLabel, subheaderLabel, dropdownLabel, saveLabel, savingLabel } = resources;

    const displayData = values.map(county => {
        return { key: county.CountyId, value: county.Name ?? county.CountyId };
    });

    const [selectedZone, selectZone] = React.useState<CountyInfo | undefined>(undefined);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    React.useEffect(() => {
        selectZone(selectedValue);
    }, [selectedValue]);

    const _onDropdownChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const countyId = event?.target?.value;
        if (countyId) {
            const selectedCounty = values.find(x => x.CountyId === countyId);
            if (selectedCounty) {
                selectZone(selectedCounty);
            }
        }
    };

    const _onSaveClick = async (): Promise<void> => {
        if (!selectedZone) {
            return;
        }
        try {
            setIsLoading(true);
            await onSelect(selectedZone);
        } catch (ex) {
            console.error(ex);
        } finally {
            setIsLoading(false);
        }
    };

    const value = selectedZone?.CountyId ?? '';

    return (
        <Modal isOpen={isOpen} contentClassName='zone-selector-modal__content' className='zone-selector-modal__dialog'>
            <ModalBody className='popup-content'>
                <YourLocation />
                <div>
                    <h2>{headerLabel}</h2>
                    <p>{subheaderLabel}</p>
                </div>

                <div className='other-regions'>
                    <p>
                        <strong>{dropdownLabel}</strong>
                    </p>
                    <div className='combo-box'>
                        <DropdownWithSearch
                            {...{
                                id: 'zone-county-selector',
                                name: '',
                                className: 'zone-county-selector',
                                value: value,
                                displayData,
                                isDisabled: isLoading,
                                onChange: _onDropdownChange
                            }}
                        />
                    </div>
                </div>

                {errorMessage && (
                    <div>
                        <p style={{ color: 'red', fontSize: '15px' }}>{errorMessage}</p>
                    </div>
                )}

                <button className='save-button' disabled={!value || isLoading} onClick={_onSaveClick}>
                    {isLoading ? savingLabel : saveLabel}
                </button>
            </ModalBody>
        </Modal>
    );
};
